/* jp-drawer.js — progressive behavior for the mobile navigation drawer.
   Native details/links remain complete without JS; enhancement keeps one main
   navigation branch open at a time and publishes disclosure state for older AT. */
(() => {
  if (window.__jpDrawerInit) return;
  window.__jpDrawerInit = true;

  const pubSubEvents = () => (typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null);

  const init = (drawer) => {
    if (!drawer || drawer.__jpDrawerBound) return;
    drawer.__jpDrawerBound = true;
    const body = drawer.querySelector('.jp-drawer__body');
    const accordions = Array.from(drawer.querySelectorAll('.jp-drawer__acc'));

    const sync = (details) => {
      const summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    };

    accordions.forEach((details) => {
      sync(details);
      details.addEventListener('toggle', () => {
        sync(details);
        if (!details.open) return;
        accordions.forEach((other) => {
          if (other !== details && other.open) { other.open = false; sync(other); }
        });
      });
    });

    if (body) {
      const syncScroll = () => drawer.classList.toggle('is-body-scrolled', body.scrollTop > 4);
      body.addEventListener('scroll', syncScroll, { passive: true });
      syncScroll();
    }
  };

  let cartTimer = 0;
  const syncCart = (cart) => {
    document.querySelectorAll('[data-jp-drawer-cart]').forEach((snap) => {
      const count = Number(cart && cart.item_count) || 0;
      snap.hidden = count === 0;
      const countEl = snap.querySelector('[data-jp-drawer-cart-count]');
      const totalEl = snap.querySelector('[data-jp-drawer-cart-total]');
      if (countEl) countEl.textContent = String(count);
      if (totalEl) {
        const currency = snap.dataset.currency || cart.currency || 'GBP';
        try {
          totalEl.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency', currency, minimumFractionDigits: cart.total_price % 100 ? 2 : 0
          }).format(cart.total_price / 100);
        } catch { totalEl.textContent = (cart.total_price / 100).toFixed(2); }
      }
    });
  };
  const refreshCart = () => {
    window.clearTimeout(cartTimer);
    cartTimer = window.setTimeout(() => {
      const root = window.Shopify?.routes?.root || '/';
      fetch(root + 'cart.js').then((response) => {
        if (!response.ok) throw new Error('http');
        return response.json();
      }).then(syncCart).catch(() => {});
    }, 120);
  };

  const boot = () => document.querySelectorAll('[data-jp-layer="drawer"]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('jp:layer:open', (event) => {
    if (!event.detail || event.detail.id !== 'drawer') return;
    const drawer = document.querySelector('[data-jp-layer="drawer"]');
    init(drawer);
    const body = drawer && drawer.querySelector('.jp-drawer__body');
    if (body) { body.scrollTop = 0; drawer.classList.remove('is-body-scrolled'); }
  });
  document.addEventListener('DOMContentLoaded', () => {
    const events = pubSubEvents();
    if (typeof subscribe === 'function' && events?.cartUpdate && !window.__jpDrawerCartSubscribed) {
      window.__jpDrawerCartSubscribed = true;
      subscribe(events.cartUpdate, refreshCart);
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && !bubble.__jpDrawerObserved) {
      bubble.__jpDrawerObserved = true;
      new MutationObserver(refreshCart).observe(bubble, { childList: true, subtree: true });
    }
  });
})();
